import React from "react"
import { gql, useSubscription } from "@apollo/client"
import { CircularProgress, Grid } from "@mui/material"
import ActiveFeatureView from "./ActiveFeatureView"
import AreaInfo from "./AreaInfo"

const AREA_DETAILS_QUERY = gql`
  subscription areaDetails($areaId: Int!) {
    area_by_pk(id: $areaId) {
      description
      id
      farm_id
      name
      geographic_features(where: { type: { _eq: "growing_line" }, archived_at: { _is_null: true } }) {
        id
        name
        type
        geometry_type
        metadata
        observations {
          id
          data
          payload_version
          observation_date
          date_added
          observation_attachments {
            id
            file {
              id
              key
            }
          }
        }
      }
      marks: geographic_features(where: { type: { _eq: "marker_point" }, archived_at: { _is_null: true } }) {
        id
        name
        type
        geometry_type
        metadata
        observations {
          id
          data
          payload_version
          observation_date
          date_added
          observation_attachments {
            id
            file {
              id
              key
            }
          }
        }
      }
    }
  }
`

export default function AreaDetail({ activeArea, activeLine, activeMark, onArchiveArea, onArchiveLine, onArchiveMark }) {
  const { loading, error, data } = useSubscription(AREA_DETAILS_QUERY, {
    variables: { areaId: activeArea },
  })
  
  // Determine the active feature ID (either a line or mark)
  const activeFeatureId = activeLine || activeMark
  
  if (loading) return <CircularProgress />
  if (error) return <p>Error :(</p>
  
  return (
    <Grid container spacing={12}>
      {/* Show area info only if there's no active feature */}
      {!activeFeatureId && (
        <AreaInfo 
          area={data.area_by_pk} 
          onArchive={() => onArchiveArea(activeArea)}
        />
      )}
      
      {/* Show active feature view when a line or mark is selected */}
      {activeFeatureId && (
        <Grid item xs={12}>
          <ActiveFeatureView
            activeFeature={activeFeatureId}
            allLines={data.area_by_pk.geographic_features}
            allMarks={data.area_by_pk.marks}
            onArchiveLine={onArchiveLine}
            onArchiveMark={onArchiveMark}
          />
        </Grid>
      )}
    </Grid>
  )
}
